<ul class="p-sub-column-layout02__list">
  <li *ngIf="!isUnsaved" class="p-sub-column-layout02__list-item">
    <button
      id="plan-review-plan-manipulation-menu-rename-plan-btn"
      class="p-sub-column-layout02__list-link"
      aswThrottleClick
      (throttleClick$)="openPlanSaveModal()"
      [innerHTML]="'label.rename' | staticMsg"
    ></button>
  </li>
  <li *ngIf="!isUnsaved && isPlanValid" class="p-sub-column-layout02__list-item">
    <button
      id="plan-review-plan-manipulation-menu-deeplink-btn"
      class="p-sub-column-layout02__list-link"
      aswThrottleClick
      (throttleClick$)="showTemporaryUrl('DPL')"
      [innerHTML]="'label.generateDeepLink' | staticMsg"
    ></button>
  </li>
  <li *ngIf="!isUnsaved && isPlanValid" class="p-sub-column-layout02__list-item">
    <button
      id="plan-review-plan-manipulation-menu-share-plan-btn"
      class="p-sub-column-layout02__list-link"
      aswThrottleClick
      (throttleClick$)="showTemporaryUrl('SHR')"
      [innerHTML]="'label.share' | staticMsg"
    ></button>
  </li>
  <li *ngIf="!isUnsaved" class="p-sub-column-layout02__list-item p-sub-column-layout02__list-item--red">
    <button
      id="plan-review-plan-manipulation-menu-delete-plan-btn"
      class="p-sub-column-layout02__list-link"
      aswThrottleClick
      (throttleClick$)="deletePlan()"
      [innerHTML]="'label.delete' | staticMsg"
    ></button>
  </li>
</ul>
